import type { ROLE } from "@/types/user.ts";

export const ROLES: Record<string, ROLE> = {
  ADMIN: "ADMIN",
  AGENT: "AGENT",
};
